import { render, staticRenderFns } from "./VueClock.vue?vue&type=template&id=1027f71c&scoped=true"
import script from "./VueClock.vue?vue&type=script&lang=js"
export * from "./VueClock.vue?vue&type=script&lang=js"
import style0 from "./VueClock.vue?vue&type=style&index=0&id=1027f71c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1027f71c",
  null
  
)

export default component.exports